<template>
  <div
    class="reservation-block"
    :class="statusClass"
    @click="$emit('click', reservation)"
  >
    <span class="reservation-block__name text-truncate">
      {{ customerName }}
    </span>
    <span class="reservation-block__count">
      {{ reservation.attributes.customerCount }}名
    </span>
    <span
      v-if="missingItems.length > 0"
      class="reservation-block__warn"
      :title="`来店処理には${missingItems.join('・')}の入力が必要です`"
    >
      ⚠ 要{{ missingItems.join('・') }}
    </span>
    <v-icon
      v-if="status === 'confirmed' && checkInEnabled"
      class="reservation-block__check-in"
      x-small
      color="white"
      title="卓作成"
      @click.stop="$emit('check-in', reservation)"
    >
      {{ icons.mdiSofaSingle }}
    </v-icon>
  </div>
</template>

<script>
import { mdiSofaSingle } from '@mdi/js'
import { checkInMissingItems } from '@/views/waiter/reservations/reservationDisplayUtils'

export default {
  name: 'ReservationBlock',
  props: {
    reservation: {
      type: Object,
      required: true,
    },
    // 来店処理（卓作成）を許可するか。予約日=当営業日のときのみ true
    checkInEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icons: { mdiSofaSingle },
    }
  },
  computed: {
    attrs() {
      return this.reservation.attributes || {}
    },
    status() {
      return this.attrs.status
    },
    statusClass() {
      return {
        'reservation-block--tentative': this.status === 'tentative',
        'reservation-block--confirmed': this.status === 'confirmed',
        'reservation-block--checked-in': this.status === 'checked_in',
        'reservation-block--completed': this.status === 'completed',
      }
    },
    customerName() {
      const { customers } = this.attrs
      if (!customers || customers.length === 0) return '(未設定)'

      return customers[0].name + (customers.length > 1 ? ` 他${customers.length - 1}名` : '')
    },
    // 来店処理前の予約（仮予約・確定）で入力が不足している項目
    missingItems() {
      if (!['tentative', 'confirmed'].includes(this.status)) return []

      return checkInMissingItems(this.attrs)
    },
  },
}
</script>

<style scoped>
.reservation-block {
  border-radius: 4px;
  padding: 2px 6px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  min-height: 32px;
  z-index: 1;
}

.reservation-block:hover {
  opacity: 0.85;
}

.reservation-block__name {
  font-weight: 500;
}

.reservation-block__count {
  opacity: 0.8;
  font-size: 11px;
}

/* 来店処理の必須項目が不足している予約の警告（色付き背景の上でも読めるように白地） */
.reservation-block__warn {
  background: rgba(255, 255, 255, 0.92);
  color: #b45309;
  font-size: 10.5px;
  font-weight: 700;
  border-radius: 8px;
  padding: 0 6px;
  flex: 0 0 auto;
}

.reservation-block__check-in {
  margin-left: auto;
  cursor: pointer;
}

.reservation-block__check-in:hover {
  opacity: 0.7;
}

.reservation-block--tentative {
  background-color: #9e9e9e;
  color: white;
}

.reservation-block--confirmed {
  background-color: #1976d2;
  color: white;
}

.reservation-block--checked-in {
  background-color: #4caf50;
  color: white;
}

.reservation-block--completed {
  background-color: #e0e0e0;
  color: #666;
}
</style>
